var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 53,
    viewBox: "0 0 90 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.87048 3.9067L1 7.09843L1.0061 52.1008H16.7876V52.2953H72.3005L75.1503 49.9015L78.057 50.5285L81.8756 49.0466L83.1865 46.8238L88.772 43.5751L83.5285 38.4456L83.2435 35.7098L81.5907 35.5388L81.4767 31.8342L83.4715 29.9534L82.5596 27.6736L87.4611 20.4352L89 19.8653L88.601 18.3264L86.3212 18.2124L83.5855 15.5337L83.8135 12L82.3316 9.49222L80.6218 9.66321L78.7979 6.75647H12.57V1L7.0985 4.47668L6.87048 3.9067Z",
    fill: "#273137",
    fillOpacity: 0.1,
    stroke: "#273137",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPa);
export default __webpack_public_path__ + "static/media/PA.400ac4b7cbf0564672ed82730a1a48b3.svg";
export { ForwardRef as ReactComponent };